import React from 'react';
import './ProductCard.css';

interface AddProductCardProps {
  onClick: () => void;
}

const AddProductCard: React.FC<AddProductCardProps> = ({ onClick }) => {
  return (
    <div className="product-card add-product-card" onClick={onClick} role="button" tabIndex={0} onKeyPress={e => { if (e.key === 'Enter') onClick(); }}>
      <div className="add-product-card-content">
        <span className="add-product-icon">+</span>
        <span className="add-product-text">Add product</span>
      </div>
    </div>
  );
};

export default AddProductCard; 